// removed by extract-text-webpack-plugin
module.exports = {"item":"_3RbNYMT8xNpptYdCFHWwjR","body":"xAfmzArFBMpDPePk0kGXV","rewardImage":"_161ejnLSdz2WMu6nFutRES","contentView":"oSm23cUKdEnXvMhFlSAgk","title":"_2vfF65rUTdCIvCDRidPVZB","duration":"_31owsRgIpAniSeJq7z_Gwb","groupPrice":"_2rW-lWNs-XyJfDzLTSR6J","newPrice":"_2WzphFktdthPygIIgiafcE","oldPrice":"_1FyR2YLebfVFXvMM5sbg_F","middleView":"_3Jvkfbfh5NKOuF1Kprz9Um","dashLine":"_23PYSGdxfyqAd5rX1XLTe3","footer":"_1MKf7jRQo4bJf5r6WFAofd","btn":"_3eYPoXh2y88H9uc91EY87s","active":"_3RlWjxd3-pCvbdiSaKlj9Q","customModal":"_1x0Jixf80wxqL1_Fo7WOgV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/HomeService/ServiceItemSmall.scss
// module id = 1121
// module chunks = 0